// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"195":"08ce893905c37a9720f5","227":"bf414cf3c6504950873a","613":"67541d137e6eec7dab4c"}[chunkId] + ".css";
};